import { render, staticRenderFns } from "./UserReportTable.vue?vue&type=template&id=607d68df&"
import script from "./UserReportTable.vue?vue&type=script&lang=js&"
export * from "./UserReportTable.vue?vue&type=script&lang=js&"
import style0 from "./UserReportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports